/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Word3Inputs */

const en_wc_vs_word3 = /** @type {(inputs: Wc_Vs_Word3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft Copilot for drafting and rewriting inside the document.`)
};

/**
* | output |
* | --- |
* | "Microsoft Copilot for drafting and rewriting inside the document." |
*
* @param {Wc_Vs_Word3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_word3 = /** @type {((inputs?: Wc_Vs_Word3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Word3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_word3(inputs)
});
export { wc_vs_word3 as "wc.vs.word3" }